module.exports = __webpack_public_path__ + "static/media/1001058DO.b0516603.jpg";